import { Component } from '@angular/core';

/**
 * Simple presentational component with logout button.
 */
@Component({
    selector: 'ssf-logout',
    template: require('./logout.component.html'),
    styles: [require('./logout.component.scss')]
})
export class LogoutComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/logout/logout.component.ts